// extracted by mini-css-extract-plugin
export const grid = "enemies-module--grid--1IdUs";
export const enemyContent = "enemies-module--enemyContent--3EZyZ";
export const enemyNav = "enemies-module--enemyNav--3xCVL";
export const navigation = "enemies-module--navigation--7LNXO";
export const active = "enemies-module--active--1BKkf";